<template>
  <div class="bc-spec-mall">
    <div class="bc-spec-mall__inner">
      <h1 class="bc-spec-mall__title">{{ $T('观众中心商城标题') }}</h1>
      <p class="bc-spec-mall__desc">{{ $T('观众中心商城说明') }}</p>

      <div v-if="loading" class="bc-spec-mall__empty">{{ $T('观众中心加载中') }}</div>
      <div v-else-if="!list.length" class="bc-spec-mall__empty">{{ $T('观众中心暂无商品') }}</div>
      <div v-else class="bc-spec-mall__grid">
        <a
          v-for="item in list"
          :key="item.id"
          class="bc-spec-mall__card"
          href="javascript:;"
          @click.prevent="goDetail(item.id)"
        >
          <div class="bc-spec-mall__pic-wrap">
            <img class="bc-spec-mall__pic" :src="item.pic_url" :alt="goodsTitle(item)" />
          </div>
          <div class="bc-spec-mall__meta">
            <h2 class="bc-spec-mall__name">{{ goodsTitle(item) }}</h2>
            <p class="bc-spec-mall__price">{{ money(priceText(item)) }}</p>
          </div>
        </a>
      </div>

      <div v-if="totalpage > 1" class="bc-spec-mall__pager">
        <button
          type="button"
          class="bc-spec-mall__page-btn"
          :disabled="p <= 1"
          @click="loadPage(p - 1)"
        >
          {{ $T('观众中心上一页') }}
        </button>
        <span class="bc-spec-mall__page-num">{{ p }} / {{ totalpage }}</span>
        <button
          type="button"
          class="bc-spec-mall__page-btn"
          :disabled="p >= totalpage"
          @click="loadPage(p + 1)"
        >
          {{ $T('观众中心下一页') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { spectatorMoney } from '@/utils/spectatorMoney';

export default {
  name: 'SpectatorMall',
  data() {
    return {
      list: [],
      loading: true,
      p: 1,
      totalpage: 1,
    };
  },
  mounted() {
    document.title = this.$T('观众中心商城标题');
    this.loadPage(1);
  },
  methods: {
    money: spectatorMoney,
    goodsTitle(item) {
      if (this.$getLocale() === 'en-US' && item.title_en) {
        return item.title_en;
      }
      return item.title || '';
    },
    priceText(item) {
      const range = item.price_range;
      if (!range || !range.length) {
        return '0';
      }
      const min = range[0];
      const max = range[1];
      if (min === max || max == null) {
        return min;
      }
      return `${min} - ${max}`;
    },
    loadPage(page) {
      const that = this;
      that.loading = true;
      that.$api.get(
        '/api/goods/goodsList',
        { p: page, step: 12 },
        (res) => {
          that.list = (res.data && res.data.list) || [];
          that.p = (res.data && res.data.currentpage) || page;
          that.totalpage = (res.data && res.data.totalpage) || 1;
          that.loading = false;
          that.enrichListI18n();
        },
        () => {
          that.list = [];
          that.loading = false;
        }
      );
    },
    // 线上 goodsList 若未带 title_en，从详情补齐（详情接口已有双语字段）
    enrichListI18n() {
      if (this.$getLocale() !== 'en-US' || !this.list.length) {
        return;
      }
      const that = this;
      that.list.forEach((item, index) => {
        if (item.title_en) {
          return;
        }
        that.$api.get(
          '/api/goods/goodsDetail',
          { id: item.id },
          (res) => {
            const g = (res.data && res.data.data) || {};
            if (!g || !that.list[index] || that.list[index].id !== item.id) {
              return;
            }
            if (g.title_en) {
              that.$set(that.list[index], 'title_en', g.title_en);
            }
            if (g.desc_en) {
              that.$set(that.list[index], 'desc_en', g.desc_en);
            }
          }
        );
      });
    },
    goDetail(id) {
      this.$router.push({ path: '/spectator/goods', query: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-spec-mall {
  background: #f3f4f6;
  min-height: 50vh;
  padding: 48px 24px 80px;
}
.bc-spec-mall__inner {
  max-width: 1100px;
  margin: 0 auto;
}
.bc-spec-mall__title {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 700;
  color: #1e2842;
  text-align: center;
}
.bc-spec-mall__desc {
  margin: 0 0 36px;
  font-size: 15px;
  line-height: 1.6;
  color: #5b6478;
  text-align: center;
}
.bc-spec-mall__empty {
  text-align: center;
  color: #6b7280;
  padding: 48px 0;
  font-size: 15px;
}
.bc-spec-mall__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.bc-spec-mall__card {
  display: block;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 6px 20px rgba(30, 40, 66, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.bc-spec-mall__card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(30, 40, 66, 0.1);
  color: inherit;
}
.bc-spec-mall__pic-wrap {
  aspect-ratio: 1;
  background: #eef0f4;
  overflow: hidden;
}
.bc-spec-mall__pic {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bc-spec-mall__meta {
  padding: 14px 14px 16px;
}
.bc-spec-mall__name {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1e2842;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.8em;
}
.bc-spec-mall__price {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #c2410c;
}
.bc-spec-mall__pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 36px;
}
.bc-spec-mall__page-btn {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  color: #1e2842;
}
.bc-spec-mall__page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bc-spec-mall__page-num {
  font-size: 14px;
  color: #6b7280;
}

@media (max-width: 960px) {
  .bc-spec-mall__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 640px) {
  .bc-spec-mall {
    padding: 32px 16px 64px;
  }
  .bc-spec-mall__title {
    font-size: 22px;
  }
  .bc-spec-mall__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// SpectatorMall.vue?c2974dc4